import { useSelector } from "react-redux";
import {
  getAuthentication,
  getIsLoginLoading,
  getIsUserAdmin,
  getUser,
  getUserId,
  getUserLogin,
} from "../selectors";

export const useUser = () => useSelector(getUser);
export const useUserId = () => useSelector(getUserId);
export const useUserLogin = () => useSelector(getUserLogin);
export const useAuthentication = () => useSelector(getAuthentication);
export const useIsLoginLoading = () => useSelector(getIsLoginLoading);
export const useIsAdmin = () => useSelector(getIsUserAdmin);
